/**
 * Uygulamanın kendi temalı onay / metin pencereleri (tarayıcının confirm() ve prompt() pencereleri yerine).
 * Pencereyi App kökündeki CustomAlertModal çizer; alert() zaten orada uygulama genelinde yakalanıyor.
 * confirm()/prompt() eşzamanlı olduğu için yakalanamaz: çağıran yer `await appConfirm(...)` kullanmalı.
 *
 *   if (!(await appConfirm('Oyundan çıkmak istiyor musun?'))) return;
 */

export interface AppConfirmOptions {
    title?: string;
    confirmText?: string;
    cancelText?: string;
    /** Silme / çıkış gibi geri dönüşü olmayan işlem: onay düğmesi kırmızı */
    danger?: boolean;
}

export interface AppPromptOptions extends AppConfirmOptions {
    defaultValue?: string;
    placeholder?: string;
}

export type AppDialogRequest =
    | { kind: 'confirm'; message: string; options: AppConfirmOptions; resolve: (ok: boolean) => void }
    | { kind: 'prompt'; message: string; options: AppPromptOptions; resolve: (value: string | null) => void };

export const APP_DIALOG_EVENT = 'app-dialog-request';

/** CustomAlertModal bağlanınca true yapar; bağlı değilse (çok erken çağrı) tarayıcı penceresine düşülür */
export function isAppDialogHostReady(): boolean {
    return typeof window !== 'undefined' && (window as any).__kpssDialogHostReady === true;
}

export function appConfirm(message: string, options: AppConfirmOptions = {}): Promise<boolean> {
    if (!isAppDialogHostReady()) return Promise.resolve(window.confirm(message));
    return new Promise<boolean>((resolve) => {
        window.dispatchEvent(new CustomEvent<AppDialogRequest>(APP_DIALOG_EVENT, { detail: { kind: 'confirm', message, options, resolve } }));
    });
}

export function appPrompt(message: string, options: AppPromptOptions = {}): Promise<string | null> {
    if (!isAppDialogHostReady()) return Promise.resolve(window.prompt(message, options.defaultValue ?? ''));
    return new Promise<string | null>((resolve) => {
        window.dispatchEvent(new CustomEvent<AppDialogRequest>(APP_DIALOG_EVENT, { detail: { kind: 'prompt', message, options, resolve } }));
    });
}
